var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (buttons, id, showBody, showCloseButton, showHeader, title) {pug_html = pug_html + "\u003Cdiv" + (" class=\"modal\""+" tabindex=\"-1\" role=\"dialog\""+pug.attr("aria-labelledby", 'shared-component-dialog-title-' + id, true, true)) + "\u003E\u003Cdiv class=\"modal-dialog\"\u003E\u003Cdiv class=\"modal-content\"\u003E";
if (showHeader) {
pug_html = pug_html + "\u003Cdiv class=\"modal-header\"\u003E";
if (showCloseButton) {
pug_html = pug_html + "\u003Cbutton class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"\u003E\u003Cspan aria-hidden=\"true\"\u003E&times;\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E";
}
if (title) {
pug_html = pug_html + "\u003Ch4" + (" class=\"modal-title\""+pug.attr("id", 'shared-component-dialog-title-' + id, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"modal-empty-header\"\u003E\u003C\u002Fdiv\u003E";
}
if (showBody) {
pug_html = pug_html + "\u003Cdiv class=\"modal-body\"\u003E\u003C\u002Fdiv\u003E";
}
if (buttons.length > 0) {
pug_html = pug_html + "\u003Cdiv class=\"modal-footer\"\u003E";
// iterate buttons
;(function(){
  var $$obj = buttons;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var button = $$obj[pug_index0];
var cls = button.class || ''
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes(["btn","btn-default",cls], [false,false,true]), false, true)+" type=\"button\""+pug.attr("button-name", button.name, true, true)+pug.attr("disabled", button.disabled, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = button.text) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var button = $$obj[pug_index0];
var cls = button.class || ''
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes(["btn","btn-default",cls], [false,false,true]), false, true)+" type=\"button\""+pug.attr("button-name", button.name, true, true)+pug.attr("disabled", button.disabled, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = button.text) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"buttons" in locals_for_with?locals_for_with.buttons:typeof buttons!=="undefined"?buttons:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"showBody" in locals_for_with?locals_for_with.showBody:typeof showBody!=="undefined"?showBody:undefined,"showCloseButton" in locals_for_with?locals_for_with.showCloseButton:typeof showCloseButton!=="undefined"?showCloseButton:undefined,"showHeader" in locals_for_with?locals_for_with.showHeader:typeof showHeader!=="undefined"?showHeader:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return pug_html;};
module.exports = template;